export interface DisabledDayFilterContext {
  today: Date;
}

export type DisabledDayFilter = (day: Date, ctx: DisabledDayFilterContext) => boolean;

export enum Weekday {
  Sunday = 0,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export function createWeekdayFilter(weekday: Weekday | readonly Weekday[]): DisabledDayFilter {
  // NOTE: Array.isArray does not work on readonly arrays correctly in TS 3.8
  return (Array.isArray as (x: unknown) => x is readonly unknown[])(weekday)
    ? (day: Date) => weekday.includes(day.getDay())
    : (day: Date) => weekday === day.getDay();
}

export const isPastDate: DisabledDayFilter = (day, { today }) => {
  if (day.getFullYear() < today.getFullYear()) {
    return true;
  } else if (day.getFullYear() > today.getFullYear()) {
    return false;
  } else if (day.getMonth() < today.getMonth()) {
    return true;
  } else if (day.getMonth() > today.getMonth()) {
    return false;
  } else if (day.getDate() < today.getDate()) {
    return true;
  } else {
    return false;
  }
};

export const isAfterDate: DisabledDayFilter = (day, { today }) => {
  if (day.getFullYear() > today.getFullYear()) {
    return true;
  } else if (day.getFullYear() < today.getFullYear()) {
    return false;
  } else if (day.getMonth() > today.getMonth()) {
    return true;
  } else if (day.getMonth() < today.getMonth()) {
    return false;
  } else if (day.getDate() > today.getDate()) {
    return true;
  } else {
    return false;
  }
};

export function combineFilters(filters: ReadonlyArray<DisabledDayFilter>): DisabledDayFilter {
  return (day, ctx) => filters.some((filter) => filter(day, ctx));
}

export interface DisabledDayConfig {
  weekdays?: readonly Weekday[] | Weekday;
  pastDates?: boolean;
}

export function createDisabledDayFilter(config: Readonly<DisabledDayConfig>) {
  const filters: Array<DisabledDayFilter> = [];
  if (config.weekdays) {
    filters.push(createWeekdayFilter(config.weekdays));
  }
  if (config.pastDates) {
    filters.push(isPastDate);
  }
  return combineFilters(filters);
}
